import { fork } from "@redux-saga/core/effects";
import { analyticsSaga } from "@stores/auth/analyticsSaga";
import auth from "./auth";
import preference from "./preference";

function* mainSaga() {
  yield fork(auth.saga);
  yield fork(analyticsSaga);
  yield fork(preference.saga);
}

export default mainSaga;
